import React from 'react'

export const IconChevronDown = (props) => {
  return (
    <svg viewBox="0 0 12 7" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11 1L6 6L1 1" stroke-width="0.625"/>
    </svg>
  )
}
